<main class="font" *ngIf="loaded">
  <div *ngIf="docLoaded.imageUrl !== undefined" class=newsElement-image
       [style.background-image]="'linear-gradient(to bottom, rgba(255,255,255,0) 50%, rgba(255,255,255,1) 100%), url(' + docLoaded.imageUrl + ')'">
    <img [src]="docLoaded.imageUrl" [alt]="(doc | async)">
  </div>
  <h3 class=newsElement-title>{{docLoaded.name}}</h3>
  <p class=newsElement-time>{{fd(docLoaded.time)}}</p>
  <div class=newsElement-content [innerHTML]="docLoaded.html"></div>
</main>
